var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.powered,on:{"click":_vm.toLegend}},[_vm._v(" "+_vm._s(_vm.$t("Powered by"))+" "),_c('logo-gold')],1)}
var staticRenderFns = []

export { render, staticRenderFns }